import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const EditorOutroIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 5.5C6 5.22386 6.22386 5 6.5 5C6.77614 5 7 5.22386 7 5.5V16.5C7 16.7761 6.77614 17 6.5 17C6.22386 17 6 16.7761 6 16.5V5.5ZM4 10.5C4 10.2239 4.22386 10 4.5 10C4.77614 10 5 10.2239 5 10.5V16.5C5 16.7761 4.77614 17 4.5 17C4.22386 17 4 16.7761 4 16.5V10.5ZM9 8.5C9 8.22386 8.77614 8 8.5 8C8.22386 8 8 8.22386 8 8.5V16.5C8 16.7761 8.22386 17 8.5 17C8.77614 17 9 16.7761 9 16.5V8.5ZM10 10.5C10 10.2239 10.2239 10 10.5 10C10.7761 10 11 10.2239 11 10.5V16.5C11 16.7761 10.7761 17 10.5 17C10.2239 17 10 16.7761 10 16.5V10.5ZM13 11.5C13 11.2239 12.7761 11 12.5 11C12.2239 11 12 11.2239 12 11.5V16.5C12 16.7761 12.2239 17 12.5 17C12.7761 17 13 16.7761 13 16.5V11.5ZM14 12.5C14 12.2239 14.2239 12 14.5 12C14.7761 12 15 12.2239 15 12.5V16.5C15 16.7761 14.7761 17 14.5 17C14.2239 17 14 16.7761 14 16.5V12.5ZM17 13.5C17 13.2239 16.7761 13 16.5 13C16.2239 13 16 13.2239 16 13.5V16.5C16 16.7761 16.2239 17 16.5 17C16.7761 17 17 16.7761 17 16.5V13.5ZM18 14.5C18 14.2239 18.2239 14 18.5 14C18.7761 14 19 14.2239 19 14.5V16.5C19 16.7761 18.7761 17 18.5 17C18.2239 17 18 16.7761 18 16.5V14.5ZM21 15.5C21 15.2239 20.7761 15 20.5 15C20.2239 15 20 15.2239 20 15.5V16.5C20 16.7761 20.2239 17 20.5 17C20.7761 17 21 16.7761 21 16.5V15.5Z"
        fill={fillColor || '#B8BDC1'}
      />
    </svg>
  );
};

export { EditorOutroIcon };
